/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Open_LinkInputs */

const en_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open link`)
};

const ar_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتح الرابط`)
};

const bn_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লিংক খুলুন`)
};

const de_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link öffnen`)
};

const es_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir enlace`)
};

const fr_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le lien`)
};

const pt_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir link`)
};

const zh_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开链接`)
};

const tr_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağlantıyı aç`)
};

const ru_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть ссылку`)
};

const pl_btn_open_link = /** @type {(inputs: Btn_Open_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz link`)
};

/**
* | output |
* | --- |
* | "Open link" |
*
* @param {Btn_Open_LinkInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const btn_open_link = /** @type {((inputs?: Btn_Open_LinkInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Open_LinkInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_btn_open_link(inputs)
	if (locale === "bn") return bn_btn_open_link(inputs)
	if (locale === "de") return de_btn_open_link(inputs)
	if (locale === "es") return es_btn_open_link(inputs)
	if (locale === "fr") return fr_btn_open_link(inputs)
	if (locale === "pt") return pt_btn_open_link(inputs)
	if (locale === "zh") return zh_btn_open_link(inputs)
	if (locale === "tr") return tr_btn_open_link(inputs)
	if (locale === "ru") return ru_btn_open_link(inputs)
	if (locale === "pl") return pl_btn_open_link(inputs)
	return en_btn_open_link(inputs)
});